import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PROMOTION_CAMPAIGN_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getPromotionCampaignAction = createAsyncThunk(
    'price/getPromotionCampaignAction',
    async (promotionCampaignId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PROMOTION_CAMPAIGN_PATH }/${ promotionCampaignId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getPromotionCampaignSlice = createSlice({
    name: 'getPromotionCampaignsSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidatePromotionCampaign() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getPromotionCampaignAction.pending, () => STATE__API__STARTED);
        builder.addCase(getPromotionCampaignAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getPromotionCampaignAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidatePromotionCampaign } = getPromotionCampaignSlice.actions;
export const getPromotionCampaignState = (state) => state.price.getPromotionCampaign;
export default getPromotionCampaignSlice.reducer;